import Svg from '../generated/XCircle';
import { Icon, type IconProps } from './Icon';

export const XCircleIcon = (props: IconProps) => <Icon component={Svg} name="xCircle" {...props} />;
